import { IconButton } from '@mui/material';
import { TextField } from '../TextField';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

type CopyTextFieldProps = {
  name: string;
  label: string;
  value: string;
  disabled?: boolean;
  sx?: any;
  onCopy?: (value: string) => void;
  iconColor?: string;
};

export const CopyTextField = ({ name, label, value, disabled = false, sx, onCopy, iconColor }: CopyTextFieldProps) => {
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(value);
      onCopy?.(value);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <TextField
      disabled
      name={name}
      label={label}
      value={value}
      sx={sx}
      InputLabelProps={{
        shrink: true
      }}
      InputProps={{
        endAdornment: (
          <IconButton disabled={disabled || !value} onClick={copyToClipboard}>
            <ContentCopyIcon sx={{ color: iconColor ?? null }} />
          </IconButton>
        )
      }}
    />
  );
};
